import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listFilter',
  pure: true
})
export class ListFilterPipe implements PipeTransform {


  public searchData : any = []
  transform(items: any[], searchText: string): any[] {
    
    if (!items) return [];
    if (!searchText) return items;
  

    return items.filter(item => {

      return Object.keys(item).some(key => {
          if(key == 'fullName' || key == 'categoryName' || key == 'majorSubject' || key == 'panelName'){             
                return String(item[key]).toLowerCase().includes(searchText.toLowerCase());           
          }
      });
    });
   }

  // if(searchText){
  //   console.log('items are present')
  // this.searchData = this.searchRecursive(items,searchText)

    
  // }


  // if(searchText && this.searchData.length == 0){
  //   console.log('items are not present') 
    
  // }

  // return this.searchData



searchRecursive(items,searchText){
  return items.filter(item => {

    return Object.keys(item).some(key => {
        if(key == 'fullName' || key == 'categoryName' || key == 'majorSubject' || key == 'panelName'){             
              return String(item[key]).toLowerCase().includes(searchText.toLowerCase());           
        }
    });
  });
 }



}



// else if(key == 'rgaRoleViewDtoList'){
//   for(let i=0 ; i< item[key].length ; i++){
//     for(let prop in item[key][i]){
//       if(prop == 'fullName' || prop == 'categoryName'){
//         return String(item[key][i][prop]).toLowerCase().includes(searchText.toLowerCase())
//       }
//     }
//   }
// }